import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import CarePlanService from "../../Services/CarePlanService";
import { FaPills } from "react-icons/fa";
import { message, Modal } from "antd";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoCloseCircleSharp } from "react-icons/io5";

function CarePlanMed({ selectedDate }) {
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [medicine, setMedicine] = useState([]);
  const [createdMedicine, setCreatedMedicine] = useState([]);
  const [loading, setLoading] = useState(true);
  const [change, setChange] = useState(false);

  const formatToReadableDate = (isoDateString) => {
    return dayjs(isoDateString).format("dddd D MMMM YYYY");
  };

  const getPatientMed = async () => {
    setLoading(true);
    let payload = {
      patientCode: patObj?.patientId,
      fromDate: dayjs(selectedDate).format("MM/DD/YYYY"),
      rpm: "Y",
    };

    let payload2 = {
      patientCode: patObj?.patientId,
      fromDate: dayjs(selectedDate).format("MM/DD/YYYY"),
      // rpm: "Y",
    };

    try {
      let result = await CarePlanService.GetPatientMedication(payload);
      let result2 = await CarePlanService.GetPatientCreatedMedication(payload2);
      setMedicine(result.data);
      setCreatedMedicine(result2.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPatientMed();
  }, [selectedDate]);

  const handleCreateMedicinePost = async (type) => {
    const updatedMedicines = medicine.map((med) => ({
      ...med,
      medicationTaken: type,
      givenDate: dayjs(selectedDate).format("YYYY-MM-DD HH:mm:ss"),
    }));

    try {
      let result = await CarePlanService.UpdateMedicationStatus(
        updatedMedicines
      );
      getPatientMed();
      setChange(false);
      message.success("Medicine Updated Successfully....");
    } catch (error) {
      console.error("lof", error);
    }
  };
  const someTaken = medicine.some((med) => med.medicationTaken === "N");

  return (
    <div className="">
      <div className="flex gap-2 mt-3 px-3">
        <span className="font-bold text-sm font-inter">
          {formatToReadableDate(selectedDate)}
        </span>
      </div>
      <hr className="mt-2" />
      {loading ? (
        <div className="flex flex-col items-center justify-center mt-5 text-gray-500 font-medium">
          <FaPills className="text-2xl mb-1 animate-spin" />
          Loading medicines...
        </div>
      ) : (
        <div className=" space-y-4">
          <div className="grid grid-cols-4 sm:grid-cols-3 md:grid-cols-4 gap-3 p-4 max-h-[100px] overflow-y-auto scrollWidth pr-2">
            {medicine && medicine.length > 0 ? (
              medicine.map((med, index) => (
                <div
                  key={index}
                  className="border rounded-lg shadow-sm p-2 bg-white h-full w-full"
                >
                  <h4 className="text-sm font-medium mb-2 text-[#189FAA]">
                    {med.drugName}
                  </h4>
                  <div className="flex justify-between text-sm text-gray-600">
                    <div className="flex items-center gap-1">
                      <div className="font-bold text-xs">Frequency:</div>
                      <span className="text-sm font-medium text-[#189FAA]">
                        {med.frequency}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-4 text-center text-gray-500 font-medium">
                No Medicine Data updated
              </div>
            )}
          </div>
          <div className="bg-white h-10 flex items-center px-4 border border-t-2">
            {medicine.length > 0 && createdMedicine.length === 0 && (
              <div className="flex items-center gap-3">
                <span className="text-sm font-bold font-inter">
                  Took all medications today?
                </span>
                <button
                  onClick={() => handleCreateMedicinePost("N")}
                  className="px-4 py-1 border rounded-full text-sm text-gray-600 hover:bg-gray-100"
                >
                  No
                </button>
                <button
                  onClick={() => handleCreateMedicinePost("Y")}
                  className="px-4 py-1 bg-[#00a0c8] text-white rounded-full text-sm hover:bg-[#008bb0]"
                >
                  Yes
                </button>
              </div>
            )}

            {!change && medicine.length > 0 && createdMedicine.length > 0 && (
              <div className="">
                {createdMedicine[0]?.medicationTaken === "Y" ? (
                  <span className="flex gap-4 items-center">
                    <span className="font-medium text-sm flex items-center gap-1">
                      <IoIosCheckmarkCircle className="text-green-600 w-4 h-4" />{" "}
                      All medications taken.
                    </span>
                    <span
                      onClick={() => setChange(true)}
                      className="underline font-semibold text-[#00a0c8] text-sm font-inter cursor-pointer"
                    >
                      Change
                    </span>
                  </span>
                ) : createdMedicine[0]?.medicationTaken === "N" ? (
                  <span className="flex gap-4">
                    <span className="flex items-center gap-1 font-medium text-sm">
                      <IoCloseCircleSharp className="text-red-600 w-4 h-4" />
                      Medication Not Taken
                    </span>
                    <span
                      onClick={() => setChange(true)}
                      className="underline font-semibold text-sm font-inter cursor-pointer text-[#00a0c8]"
                    >
                      Change
                    </span>
                  </span>
                ) : null}
              </div>
            )}

            {change && (
              <div className="flex items-center gap-3">
                <span className="text-sm font-semibold text-gray-800">
                  Took all medications today?
                </span>
                <button
                  onClick={() => handleCreateMedicinePost("N")}
                  className="px-4 py-1 rounded-md text-sm text-gray-800 hover:bg-gray-100"
                >
                  No
                </button>
                <button
                  onClick={() => handleCreateMedicinePost("Y")}
                  className="px-4 py-1 bg-[#00a0c8] text-white rounded-md text-sm hover:bg-[#008bb0]"
                >
                  Yes
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default CarePlanMed;
